@let $copied = copied();

<mbs-button
  [disabled]="disabled()"
  [icon]="$copied ? 'fa fa-check text-success' : 'fa fa-clone'"
  [isCtrl]="isCtrl()"
  [loading]="loading()"
  [ngbTooltip]="($copied ? 'shared:common.copiedToClipboard' : 'shared:common.copyToClipboard') | i18next: { format: 'capitalize' }"
  [square]="true"
  [triggers]="'mouseenter:mouseleave'"
  [type]="'secondary'"
  (click)="handleCopy()" />
